<div id="st-scorecards-list-live-scorecard-container" [ngClass]="{'st_common_high_padding': !is_sub_license && !isTemplate1, 'mt-4': is_sub_license}"
  class="gap-4  live-scorecard-container d-flex flex-column" [class.t1-page]="isTemplate1">
  <div id="st-scorecards-list-block" class="d-flex align-items-center"
    [ngClass]="screenWidth > 600 || !searchBarExpanded ? 'justify-content-between': 'justify-content-end'">
    <p class="tab-title" *ngIf="screenWidth > 600 || !searchBarExpanded">{{'live_scorecard'|translate}}</p>
    <div id="st-scorecards-list-search-box" class="search-box" [ngClass]="{'w-100':screenWidth < 600}">
      <stupa-common-search-bar [searchPlaceholder]="'search_by_participant_name' |translate" class="w-100"
        [ngClass]="screenWidth > 600 ? 'h-52' : ''" [searchQuery]="searchQuery" (searchChange)="onSearchChange($event)"
        (inputExpandedChange)="onSearchBarInputExpanded($event)"
        [searchbarMaxWidth]="'400px'"></stupa-common-search-bar>
    </div>
  </div>

  <div id="st-scorecards-list-scroll-container" *ngIf="live_scored_matches_list.length > 0"
    class="gap-3 d-flex flex-column scroll-container">
    <div id="st-scorecards-list-scorecard-list-container" class="scorecard-list-container">
      <ng-container *ngFor="let item of live_scored_matches_list; let j = index; trackBy: trackById">
        <div [id]="'st-scorecards-list-block-1' + j" class="gap-2 p-1 d-flex flex-column st-row-removal-host"
          [class.is-removing]="removingRowIds.has(item.__row_id)">
          <stupa-common-score-cards [item]="item" [show_arrow]="true"></stupa-common-score-cards>
          @if (removingRowIds.has(item.__row_id)) {
          <div class="match-completed-overlay d-flex align-items-center justify-content-center" aria-live="polite">
            <span class="match-completed-overlay__badge">
              <span class="match-completed-overlay__title">{{ 'completed' | translate }}</span>
            </span>
          </div>
          }
          <!-- <p class="event-name" (click)="openEvent(item.id)">
            {{ item.category.category_description }}
          </p> -->
        </div>
      </ng-container>
    </div>
    <div id="st-scorecards-list-load-more-loader" class="d-flex justify-content-center py-3" *ngIf="isLoadingMore"
      aria-live="polite">
      <stupa-skeleton-loader></stupa-skeleton-loader>
    </div>
  </div>

  <div id="st-scorecards-list-block-2" class="d-flex align-items-center justify-content-center flex-column"
    *ngIf="live_scored_matches_list.length == 0 && !loading">
    <!-- <img
      src="../../../../assets/icons_svg/no_data_illustrate.png"
      width="100"
      alt=""
    /> -->
    <div id="st-scorecards-list-text-center" class="text-center">{{'no_scorecard_found'|translate}}</div>
  </div>
  <div id="st-scorecards-list-block-3" class="d-flex align-items-center justify-content-center flex-column h-100"
    *ngIf="loading && live_scored_matches_list.length == 0 && !isTemplate1">
    <stupa-skeleton-loader></stupa-skeleton-loader>
  </div>

  <!-- TEMPLATE 1 (OTT) loading skeleton — reuses the real grid's own
       `.scorecard-list-container` so cards land in the exact cells the real
       content will, instead of a full-page spinner. -->
  @if (isTemplate1 && loading && live_scored_matches_list.length == 0) {
  <div id="st-scorecards-list-skeleton" class="scorecard-list-container" aria-hidden="true">
    <div class="t1-scl-skel-card" *ngFor="let _ of t1ScorecardSkeletonCards">
      <div class="t1-scl-skel-card__row">
        <span class="t1-scl-skel-card__name"></span>
        <span class="t1-scl-skel-card__badge"></span>
      </div>
      <span class="t1-scl-skel-card__line"></span>
      <span class="t1-scl-skel-card__line t1-scl-skel-card__line--short"></span>
    </div>
  </div>
  }
</div>